<template>
  <div id="func-0">
    <FuncionalidadeHeader :titulo="funcionalidade.nome"/>
    <el-row v-if="noticias.length">
      <el-col :span="14">
        <NoticiasCard v-for="(noticia, index) in noticias" :item="noticia" @click="goToNoticia(noticia.id)" :key="index"/>
        <el-button v-if="showButton" class="load-noticias" @click="getNoticias" :style="estiloCarregar">
          <svg-icone :icone="funcionalidade.parametros.dashboard.icone" :cor="estilo.aplicacao.corPrimariaAplicacao"/>
          CARREGAR MAIS NOTÍCIAS
        </el-button>
      </el-col>
      <el-col :span="10">
        <div class="destaque" :style="estiloFundoNoticia" @click="goToNoticia(destaque.id)">
          <span class="label-destaque" v-if="isDestaque">{{ funcionalidade.parametros.textos.tituloDestaque }}</span>
          <img v-if="destaque.foto_principal_url" :src="destaque.foto_principal_url"/>
          <p class="titulo" :style="estiloTitulo">{{ destaque.titulo }}</p>
          <p class="conteudo"> {{ destaque.conteudo }}</p>
          <div class="detalhes">
            <span class="formato" v-if="destaque.formato !== 1" :style="estiloFormato">
              <i :class="formato(destaque.formato).icon" v-if="destaque.formato !== 2"/>
              <svg-icone :url="galeriaIcone" v-if="destaque.formato === 2"/>
              {{ formato(destaque.formato).title }}
            </span>
            <span class="data">{{ formatData(destaque.data_publicacao) }}</span>
            <span v-for="(categoria, index) in destaque.categorias_nomes" :key="index">{{ categoria }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <div v-if="!noticias.length">
      <ErrorVazio :showBtn="false"
                  :titulo="funcionalidade.parametros.textos.tituloVazio"
                  :texto="funcionalidade.parametros.textos.textoVazio"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ErrorVazio from '@/components/Error/ErrorVazio'
import moment from 'moment'
import { urlIcons } from '@/utils/ImageBucket'
import { enumFormatos } from '@/views/0/Enums0'
import NoticiasCard from '@/components/cards/NoticiasCard'

export default {
  name: 'Func0Noticias',
  components: {
    FuncionalidadeHeader,
    ErrorVazio,
    NoticiasCard
  },
  data () {
    return {
      noticias: [],
      destaque: null,
      isDestaque: true,
      showButton: true
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'apiFuncionalidade']),
    ...mapGetters('SetupApp', ['estilo']),
    estiloFundoNoticia () {
      return {
        background: `${this.estilo.aplicacao.corPrimariaAplicacao}0d`
      }
    },
    estiloTitulo () {
      return {
        color: `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    estiloFormato () {
      return {
        background: `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    estiloCarregar () {
      return {
        background: `${this.estilo.aplicacao.corPrimariaAplicacao}0d`,
        color: `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    galeriaIcone () {
      return urlIcons('icon_news_gallery')
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      await this.getNoticias()
    },
    async getNoticias () {
      const noticiasAtuais = this.noticias.length
      const result = await this.apiFuncionalidade.lista({
        payload: {
          postTipoId: this.funcionalidade.parametros.postTipoId,
          numItens: noticiasAtuais + this.funcionalidade.parametros.numItemLista,
          offset: noticiasAtuais
        },
        loading: true,
        handlerErrorIgnore: [404]
      })

      if (result) {
        const data = result.data
        if (!this.noticias.length) {
          data.forEach(d => {
            if (d.destaque === 1) {
              this.destaque = d
              this.isDestaque = true
              this.noticias.push(this.destaque)
            } else {
              this.noticias.push(d)
            }
          })
          if (!this.destaque) {
            this.destaque = this.noticias[0]
            this.isDestaque = false
          }
        } else {
          data.splice(0, 1)
          data.forEach(d => {
            this.noticias.push(d)
          })
          if (noticiasAtuais === this.noticias.length) {
            this.showButton = false
          }
        }
      } else {
        this.noticias = []
      }
    },
    formatData (data) {
      return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    formato (id) {
      return enumFormatos[id]
    },
    goToNoticia (id) {
      return this.$router.push({
        path: '/0/detalhe',
        query: { idNoticia: id }
      })
    }
  }
}
</script>
